import { computed as y, defineComponent as ce, useCssVars as fe, ref as g, toRefs as he, watch as ee, nextTick as R, onMounted as ge, openBlock as pe, createBlock as me, Teleport as be, createElementVNode as b, createVNode as ye, Transition as Se, withCtx as we, withDirectives as ke, vShow as Te, renderSlot as z } from "vue";
import { useWindowSize as Ce, useElementBounding as I, useScrollLock as te } from "@vueuse/core";
import { useGesture as N, rubberbandIfOutOfBounds as G } from "@vueuse/gesture";
import { useMotionProperties as De, useMotionTransitions as xe, useMotionControls as Me } from "@vueuse/motion";
import { useFocusTrap as Pe } from "@vueuse/integrations/useFocusTrap";
function _e(o, u, a) {
  let e = (n) => o(n, ...u);
  return a === void 0 ? e : Object.assign(e, { lazy: a, lazyArgs: u });
}
function He(o, u, a) {
  let e = o.length - u.length;
  if (e === 0) return o(...u);
  if (e === 1) return _e(o, u, a);
  throw new Error("Wrong number of arguments");
}
function Oe(o, { triggerAt: u = "end", minQuietPeriodMs: a, maxBurstDurationMs: e, minGapMs: n, reducer: c = Be }) {
  let s, r, f, S, C = () => {
    let v = f;
    v !== void 0 && (f = void 0, o(v), n !== void 0 && (r = setTimeout(H, n)));
  }, H = () => {
    clearTimeout(r), r = void 0, s === void 0 && C();
  }, w = () => {
    clearTimeout(s), s = void 0, S = void 0, r === void 0 && C();
  };
  return { call: (...v) => {
    let h = s === void 0 && r === void 0;
    if ((u !== "start" || h) && (f = c(f, ...v)), !(s === void 0 && !h)) {
      if (a !== void 0 || e !== void 0 || n === void 0) {
        clearTimeout(s);
        let p = Date.now();
        S ?? (S = p);
        let W = e === void 0 ? a ?? 0 : Math.min(a ?? e, e - (p - S));
        s = setTimeout(w, W);
      }
      u !== "end" && h && C();
    }
  }, cancel: () => {
    clearTimeout(s), s = void 0, S = void 0, clearTimeout(r), r = void 0, f = void 0;
  }, flush: () => {
    w(), H();
  }, get isIdle() {
    return s === void 0 && r === void 0;
  } };
}
var Be = () => "";
function $(...o) {
  return He(Ee, o);
}
var Ee = (o, { min: u, max: a }) => u !== void 0 && o < u ? u : a !== void 0 && o > a ? a : o;
function Ie(o, u) {
  const a = y(() => o.value.sort((s, r) => s - r)), e = y(() => a.value[0]), n = y(() => a.value[a.value.length - 1]), c = y(() => {
    const s = a.value.reduce(
      (r, f) => Math.abs(f - u.value) < Math.abs(r - u.value) ? f : r
    );
    return a.value.indexOf(s);
  });
  return {
    minSnap: e,
    maxSnap: n,
    snapPoints: o,
    closestSnapPointIndex: c
  };
}
const $e = { "data-vsbs-container": "" }, We = ["data-vsbs-shadow", "data-vsbs-sheet-show"], Fe = /* @__PURE__ */ ce({
  __name: "BottomSheet",
  props: {
    duration: { default: 250 },
    snapPoints: {},
    defaultSnapPoint: {},
    blocking: { type: Boolean, default: !0 },
    canSwipeClose: { type: Boolean, default: !0 },
    canBackdropClose: { type: Boolean, default: !0 },
    expandOnContentDrag: { type: Boolean, default: !0 }
  },
  emits: ["opened", "closed", "ready", "dragging-up", "dragging-down", "minHeight", "maxHeight"],
  setup(o, { expose: u, emit: a }) {
    fe((i) => ({
      "02470502": ne.value,
      "3c3cbcbe": ue.value
    }));
    const e = o, n = a, c = g(null), s = g(null), r = g(null), f = g(null), S = g(null), C = g(null), H = g(null), w = g(!1), v = g(e.expandOnContentDrag), { height: h } = Ce(), { height: p } = I(c), { height: W } = I(s), { height: ae } = I(r), { height: oe } = I(C), Q = Pe([c, H], {
      immediate: !1,
      fallbackFocus: () => c.value || document.body
    }), k = y(
      () => Math.ceil(oe.value + W.value + ae.value)
    ), ne = y(() => `visibility ${e.duration}ms ease-in-out`), ue = y(() => `opacity ${e.duration}ms ease-in-out`), { motionProperties: D } = De(c), { push: x, stop: le, motionValues: O } = xe(), { set: M, stop: j } = Me(
      D,
      {},
      { push: x, motionValues: O, stop: le }
    ), t = g(0), l = g(0), { snapPoints: ie } = he(e), se = y(() => ie.value ?? [k.value]), {
      minSnap: P,
      maxSnap: _,
      snapPoints: T,
      closestSnapPointIndex: F
    } = Ie(se, t), L = te(document.body), V = te(document.documentElement), K = (i) => {
      i.key === "Escape" && E();
    }, re = () => {
      c.value && (t.value = Math.min(e.defaultSnapPoint ?? P.value, h.value), M({
        height: t.value,
        y: t.value
      }), x("y", 0, D, {
        type: "tween",
        easings: "easeInOut",
        bounce: 0,
        duration: e.duration
      }), w.value = !0, window.addEventListener("keydown", K), e.blocking && setTimeout(() => {
        O.value.y.get() - 0 < 0.1 && (n("opened"), Q.activate());
      }, e.duration));
    }, E = () => {
      c.value && (x("y", p.value, D, {
        type: "tween",
        bounce: 0,
        duration: e.duration
      }), w.value = !1, e.blocking && Q.deactivate(), window.removeEventListener("keydown", K), setTimeout(() => {
        O.value.y.get() - p.value < 0.1 && n("closed");
      }, e.duration));
    }, ve = () => {
      e.canBackdropClose && E();
    };
    function U(i) {
      v.value = !0, q(i);
    }
    function q(i) {
      v.value && i.preventDefault();
    }
    const X = (i) => {
      t.value = i, x("height", t.value, D, {
        type: "tween",
        easings: "easeInOut",
        bounce: 0,
        duration: e.duration
      });
    }, J = ({
      delta: [i, d],
      direction: [B, m]
    }) => {
      c.value && (l.value <= 0 && (t.value -= d), t.value <= P.value && (t.value = P.value, l.value += d, M({
        y: e.canSwipeClose ? $(l.value, { min: 0 }) : $(G(l.value, -p.value, 0, 0.5), { min: 0 })
      })), M({
        height: $(G(t.value, 0, _.value, 0.25), {
          min: 0,
          max: h.value
        })
      }), m > 0 ? n("dragging-down") : m < 0 && n("dragging-up"));
    }, A = () => {
      L.value = !1, V.value = !1, l.value = e.canSwipeClose ? [0, t.value].reduce(
        (i, d) => Math.abs(d - l.value) < Math.abs(i - l.value) ? d : i
      ) : 0, x("y", l.value, D, {
        type: "tween",
        easings: "easeInOut",
        bounce: 0,
        duration: e.duration
      }), l.value === t.value && (l.value = 0, E()), t.value = Math.min(T.value[F.value], h.value), x("height", t.value, D, {
        type: "tween",
        easings: "easeInOut",
        bounce: 0,
        duration: e.duration
      });
    }, Z = () => {
      L.value = !0, V.value = !0, t.value = p.value, l.value = O.value.y.get(), j();
    };
    N(
      {
        onDragStart: Z,
        onDrag: J,
        onDragEnd: A
      },
      {
        domTarget: s,
        drag: { filterTaps: !0 }
      }
    ), N(
      {
        onDragStart: Z,
        onDrag: J,
        onDragEnd: A
      },
      {
        domTarget: r,
        drag: { filterTaps: !0 }
      }
    ), N(
      {
        onDragStart: ({ direction: [i, d] }) => {
          L.value = !0, V.value = !0, t.value = p.value, l.value = O.value.y.get(), j();
          const B = f.value.scrollTop === 0, m = d > 0;
          T.value.length === 1 ? l.value === 0 && B && (v.value = m) : (e.expandOnContentDrag && t.value !== _.value && (v.value = !0), t.value === _.value && B && (v.value = m));
        },
        onDrag: ({ delta: [i, d], direction: [B, m] }) => {
          if (!e.expandOnContentDrag) {
            v.value = !1;
            return;
          }
          if (!c.value) return;
          l.value === 0 && v.value && e.expandOnContentDrag && (t.value -= d), t.value <= P.value && (t.value = P.value, v.value && e.expandOnContentDrag && (l.value += d), l.value = $(l.value, { min: 0, max: P.value }), M({
            y: e.canSwipeClose ? l.value : G(l.value, -p.value, 0, 0.5)
          })), t.value > _.value && (t.value = _.value), t.value = Math.min(t.value, h.value);
          const Y = f.value.scrollTop === 0;
          T.value.length === 1 ? d < 0 && l.value === 0 && Y && (v.value = !1) : t.value === _.value && (v.value = !1), M({
            height: t.value
          }), m > 0 ? n("dragging-down") : m < 0 && n("dragging-up");
        },
        onDragEnd: A
      },
      {
        domTarget: S,
        drag: { filterTaps: !0 }
      }
    );
    const de = Oe(
      () => {
        n("maxHeight", h.value), R(() => {
          t.value = T.value[F.value], X(T.value[F.value]);
        });
      },
      { minQuietPeriodMs: 50 }
    );
    return ee(h, () => {
      de.call();
    }), ee(k, () => {
      n("minHeight", k.value), T.value.length === 1 && R(() => {
        T.value[0] === k.value && X(Math.min(k.value, h.value));
      });
    }), ge(() => {
      n("minHeight", k.value), n("maxHeight", h.value), t.value = e.defaultSnapPoint ?? Number(k.value), M({
        height: t.value,
        y: t.value
      }), R(() => {
        n("ready");
      });
    }), u({ open: re, close: E, snapToPoint: X }), (i, d) => (pe(), me(be, { to: "body" }, [
      b("div", $e, [
        ye(Se, { name: "fade" }, {
          default: we(() => [
            ke(b("div", {
              ref_key: "backdrop",
              ref: H,
              "data-vsbs-backdrop": "",
              onClick: d[0] || (d[0] = (B) => ve())
            }, null, 512), [
              [Te, w.value && i.blocking]
            ])
          ]),
          _: 1
        }),
        b("div", {
          ref_key: "sheet",
          ref: c,
          "data-vsbs-shadow": !i.blocking,
          "data-vsbs-sheet-show": w.value,
          "aria-modal": "true",
          "data-vsbs-sheet": "",
          tabindex: "-1"
        }, [
          b("div", {
            ref_key: "sheetHeader",
            ref: s,
            "data-vsbs-header": "",
            onTouchmove: U
          }, [
            z(i.$slots, "header", {}, void 0, !0)
          ], 544),
          b("div", {
            ref_key: "sheetScroll",
            ref: f,
            "data-vsbs-scroll": "",
            onTouchmove: q
          }, [
            b("div", {
              ref_key: "sheetContentWrapper",
              ref: S,
              "data-vsbs-content-wrapper": ""
            }, [
              b("div", {
                ref_key: "sheetContent",
                ref: C,
                "data-vsbs-content": ""
              }, [
                z(i.$slots, "default", {}, void 0, !0)
              ], 512)
            ], 512)
          ], 544),
          b("div", {
            ref_key: "sheetFooter",
            ref: r,
            "data-vsbs-footer": "",
            onTouchmove: U
          }, [
            z(i.$slots, "footer", {}, void 0, !0)
          ], 544)
        ], 8, We)
      ])
    ]));
  }
}), Le = (o, u) => {
  const a = o.__vccOpts || o;
  for (const [e, n] of u)
    a[e] = n;
  return a;
}, Ne = /* @__PURE__ */ Le(Fe, [["__scopeId", "data-v-42bd48db"]]);
export {
  Ne as default
};
